module.exports = __webpack_public_path__ + "static/black-and-white-mountain-over-yellow-white-and-blue-sky-46253-3fc4e34b93d4bbd61f1a276f0284086f.jpg";